export class CostReviewElectricalSiteAccessibility {
  escortsRequired!: number;
  securityAccessRequired!: number;
  timeOfDayRequired!: number;
  specialConsiderationsRequired!: number;
}
